import { show as showError } from './error-toast.js';

// Product image gallery (Swiper loaded via CDN as a global)
const swiperEl = document.querySelector('.product-swiper');
if (swiperEl && typeof Swiper !== 'undefined') {
  new Swiper(swiperEl, {
    loop: swiperEl.querySelectorAll('.swiper-slide').length > 1,
    pagination: {
      el: swiperEl.querySelector('.swiper-pagination'),
      clickable: true,
    },
  });
}

const MAX_CART_QTY = 50;

const qtyInput = document.getElementById('product-qty');
const decBtn = document.querySelector('.product-form__qty .qty-btn[data-dir="-1"]');
const incBtn = document.querySelector('.product-form__qty .qty-btn[data-dir="1"]');
const form = document.querySelector('.product-form');
const submitBtn = form?.querySelector('.product-form__submit');

function clampQty(val) {
  return Math.max(1, Math.min(MAX_CART_QTY, val));
}

function syncButtons() {
  const val = parseInt(qtyInput.value) || 1;
  decBtn.disabled = val <= 1;
  incBtn.disabled = val >= MAX_CART_QTY;
}

// Enforce max 2 digits on input
qtyInput.addEventListener('input', () => {
  qtyInput.value = qtyInput.value.replace(/\D/g, '').slice(0, 2);
  syncButtons();
});

qtyInput.addEventListener('change', () => {
  const parsed = parseInt(qtyInput.value) || 1;
  if (parsed > MAX_CART_QTY) {
    showError(`MAX QUANTITY IS ${MAX_CART_QTY}.`);
  }
  qtyInput.value = clampQty(parsed);
  syncButtons();
});

document.querySelectorAll('.product-form__qty .qty-btn').forEach(btn => {
  btn.addEventListener('click', () => {
    const newVal = clampQty(parseInt(qtyInput.value || 1) + parseInt(btn.dataset.dir));
    qtyInput.value = newVal;
    syncButtons();
  });
});

syncButtons();

// Size buttons
const variantInput = document.getElementById('variant-id');
if (variantInput) {
  document.querySelectorAll('.size-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.size-btn').forEach(b => b.classList.remove('size-btn--active'));
      btn.classList.add('size-btn--active');
      variantInput.value = btn.dataset.variantId;
    });
  });
}

// Intercept form submission to validate against cart and inventory
if (form && submitBtn) {
  form.addEventListener('submit', async (e) => {
    e.preventDefault();

    const addQty = parseInt(qtyInput.value) || 1;
    const selectedVariantId = variantInput
      ? parseInt(variantInput.value)
      : parseInt(form.querySelector('input[name="id"]')?.value);

    // Get selected variant's inventory + policy from the active size button,
    // falling back to the single-variant hidden input.
    const activeBtn = document.querySelector('.size-btn--active');
    const variantSource = activeBtn || form.querySelector('input[name="id"]');
    const continueSelling = variantSource?.dataset.continueSelling === 'true';
    const variantInventory = variantSource?.dataset.inventory != null
      ? parseInt(variantSource.dataset.inventory)
      : Infinity;

    submitBtn.disabled = true;
    const origValue = submitBtn.value;
    submitBtn.value = 'CHECKING INVENTORY...';

    try {
      const cart = await fetch('/cart.js').then(r => r.json());
      const totalInCart = cart.items.reduce((sum, item) => sum + item.quantity, 0);
      const variantInCart = cart.items
        .filter(item => item.variant_id === selectedVariantId)
        .reduce((sum, item) => sum + item.quantity, 0);

      // Check max cart quantity
      if (totalInCart + addQty > MAX_CART_QTY) {
        const room = MAX_CART_QTY - totalInCart;
        if (room <= 0) {
          showError(`CART CAPACITY REACHED. MAX ${MAX_CART_QTY} ITEMS.`);
        } else {
          showError(`EXCEEDS MAX CART CAPACITY. YOU CAN ADD ${room} MORE.`);
        }
        submitBtn.disabled = false;
        submitBtn.value = origValue;
        return;
      }

      // Check inventory — skip for continue-selling variants (oversell allowed)
      if (!continueSelling && variantInCart + addQty > variantInventory) {
        const room = variantInventory - variantInCart;
        if (room <= 0) {
          showError('NO MORE AVAILABLE IN THIS SIZE.');
        } else {
          showError(`ONLY ${room} MORE AVAILABLE IN THIS SIZE.`);
        }
        submitBtn.disabled = false;
        submitBtn.value = origValue;
        return;
      }

      // All checks passed — submit via AJAX
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: selectedVariantId, quantity: addQty })
      });

      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        showError((data.description || data.message || 'FAILED TO ADD TO CART.').toUpperCase());
        submitBtn.disabled = false;
        submitBtn.value = origValue;
        return;
      }

      // Success — redirect to cart
      window.location.href = '/cart';
    } catch {
      showError('CONNECTION ERROR. PLEASE TRY AGAIN.');
      submitBtn.disabled = false;
      submitBtn.value = origValue;
    }
  });
}
